import { graphql } from "gatsby"
import * as styles from "./banner.module.scss"
import React from "react"
import { hexToRgb } from "../../../tools/functions"
import { BannerFieldsFragment } from "../../../../graphql-types"

interface BannerProps {
  data: BannerFieldsFragment
}

const Banner: React.FC<BannerProps> = ({ data }) => {
  if (!data) return null
  
  return (
    <div className={styles.container} style={{ backgroundImage: `url(${data.image?.url ?? ""})`}}>
      <div className={styles.filter} style={{ 
        backgroundColor: data.filterColor?.hex 
          ? `rgba(${hexToRgb(data.filterColor?.hex ?? "")}, ${(data.filterAlpha ?? 100) / 100})`
          : ""
      }}>
        <h1 className={styles.visuallyHidden}>
          {data.titleImage.alt || ""}
        </h1>
        <img className={styles.titleImage} src={data.titleImage.url} alt={data.titleImage.alt} style={{ backgroundColor: data.backgroundColor?.hex ?? "" }} />
        {data.subtitle && (
          <p className={styles.subtitle}>
            <div className={styles.subtitleText} style={{ color: data.textColor?.hex ?? "white", backgroundColor: data.backgroundColor?.hex ?? "" }}>{data.subtitle}</div>
          </p>
        )}
      </div>
    </div>
  )
}

export const fragment = graphql`
  fragment BannerFields on DatoCmsBanner {
    titleImage {
      alt
      format
      url
    }
    subtitle
    textColor {
      hex
    }
    backgroundColor {
      hex
    }
    image {
      alt
      format
      url
    }
    filterColor {
      hex
    }
    filterAlpha
  }
`

export default Banner
